import { render, staticRenderFns } from "./column-config.vue?vue&type=template&id=6bb30b38&scoped=true&"
import script from "./column-config.vue?vue&type=script&lang=ts&"
export * from "./column-config.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb30b38",
  null
  
)

export default component.exports